import { render } from "./tecnologia.vue?vue&type=template&id=10182002&bindings={}"
import script from "./tecnologia.vue?vue&type=script&lang=js"
export * from "./tecnologia.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./tecnologia.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script